import PageTypeC from "../components/pageTypeC/PageTypeC";
import { pagesDataC } from "../data/pagesData";

const Page3 = () => {
  return (
    <PageTypeC
      title={pagesDataC[0].title}
      text1={pagesDataC[0].text1}
      text2={pagesDataC[0].text2}
      text3={pagesDataC[0].text3}
      imageLeft={pagesDataC[0].imageLeft}
      imageCenter={pagesDataC[0].imageCenter}
      imageRight={pagesDataC[0].imageRight}
    />
  );
};

export default Page3;
